import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Phone, User, Send, CheckCircle2, Loader2 } from 'lucide-react';
import styles from './CallbackModal.module.css';
import { addCallbackRequest } from '../../CRM/services/clientService';

const CallbackModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({ name: '', mobile: '' });
  const [status, setStatus] = useState('idle'); // idle | loading | success

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');

    const leadData = {
      ...formData,
      source: "Website Auto Popup",
      createdAt: new Date().toISOString(),
    };

    try {
      await addCallbackRequest(leadData);
      setStatus('success');
    } catch (error) {
      console.error("CRM Save Failed", error);
      setStatus('idle');
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <div className={styles.overlay}>
          <motion.div 
            className={styles.backdrop} 
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            onClick={onClose}
          />

          <motion.div 
            className={styles.modal}
            initial={{ scale: 0.8, opacity: 0, y: 40 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.8, opacity: 0, y: 40 }}
            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          >
            <button className={styles.closeBtn} onClick={onClose}><X size={24}/></button>

            {status === 'success' ? (
              <div className={styles.successContent}>
                <div className={styles.successIcon}>
                  <CheckCircle2 size={50} color="#25D366" />
                </div>
                <h3>Request Sent!</h3>
                <p>We've received your details. An Ananta expert will call you back shortly.</p>
                <button className={styles.finishBtn} onClick={onClose}>Done</button>
              </div>
            ) : (
              <>
                <div className={styles.header}>
                  <div className={styles.iconBox}><Phone size={24} color="#e87355" /></div>
                  <h2>Request a <span className={styles.accent}>Callback</span></h2>
                  <p>Our experts will help you set up your AI Newsroom.</p>
                </div>

                <form onSubmit={handleSubmit} className={styles.form}>
                  <div className={styles.inputWrapper}>
                    <User size={18} className={styles.inputIcon} />
                    <input 
                      type="text" 
                      placeholder="Full Name" 
                      required 
                      value={formData.name}
                      onChange={(e) => setFormData({...formData, name: e.target.value})}
                    />
                  </div>

                  <div className={styles.inputWrapper}>
                    <Phone size={18} className={styles.inputIcon} />
                    <input 
                      type="tel" 
                      placeholder="Mobile Number" 
                      pattern="[0-9]{10}" 
                      title="Please enter 10 digit mobile number"
                      required 
                      value={formData.mobile}
                      onChange={(e) => setFormData({...formData, mobile: e.target.value})}
                    />
                  </div>

                  <button 
                    type="submit" 
                    className={styles.submitBtn} 
                    disabled={status === 'loading'}
                  >
                    {status === 'loading' ? (
                      <Loader2 className={styles.spinner} size={20} />
                    ) : (
                      <>Call Me Back <Send size={18} /></>
                    )}
                  </button>
                </form>
                <p className={styles.privacyNote}>We promise not to spam you.</p>
              </>
            )}
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default CallbackModal;